export default {
    'remaining-samples': 'Remaining samples'
}